import React, { useEffect, useState } from 'react';

import { Container } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

import {
  getLabRequestReq,
  getLabRequestReqs,
  updateLabRequestReq,
  addNewLabRequestReq
} from "../../../store/labCitec/labRequestReq/actions";
import { AnalysisRequestSaveButton } from "../../../components/Common/AnalysisRequestSaveButton";

export const SpecialRequirements = ({ props }) => {

  // console.log('SpecialRequirements props : ', props);

  // let labRequestTest;
  const role = (localStorage.getItem("authUser")) ? JSON.parse(localStorage.getItem("authUser"))?.role : ''

  const dispatch = useDispatch();

  useEffect(() => {
    // labRequestTest = props.id;
    dispatch(getLabRequestReqs(`?limit=20&page=0&labRequestTest=${props?.match?.params?.rowInfoLabTestViewId}`))
  }, [])

  useEffect(() => {
    // labRequestTest = props.id;
    dispatch(getLabRequestReqs(`?limit=20&page=0&labRequestTest=${props?.match?.params?.rowInfoLabTestViewId}`))
  }, [props?.match?.params?.rowInfoLabTestViewId])

  const { labRequestTests, labRequestRequirements, labRequestEssays } = useSelector(
    state => ({
      labRequestTests: state.labRequestTestReducer.labRequestTests,
      labRequestEssays: state.labRequestEssayReducer.labRequestEssays,
      labRequestRequirements: state.labRequestReqReducer.labRequestReqs,
    })
  );

  useEffect(() => {
    if (labRequestRequirements.length > 0) {
      // console.log('si habia requerimientos');
      setEditorState(labRequestRequirements[0].requirements);
    } else {
      // console.log('No habia requerimientos');
      setEditorState('');
    }
  }, [labRequestRequirements])

  // console.log('labRequestRequirements: ', labRequestRequirements);

  // const labRequestRequirement = labRequestRequirements.length > 0 ? labRequestRequirements[0] : null;
  const initialRequirements = labRequestRequirements.length > 0 ? (labRequestRequirements[0].requirements || '') : '';

  const [enableEmptyAlert, setEnableEmptyAlert] = useState(false);
  const [enableStoreAlert, setEnableStoreAlert] = useState(false);

  const [editorState, setEditorState] = useState(initialRequirements || '');

  // setEditorState(initialRequirements);

  // useEffect(() => {
  //   setEditorState(initialRequirements);
  // }, [activeTab])


  const saveInfo = () => {
    if (!editorState) return setEnableEmptyAlert(true);

    if (labRequestRequirements.length > 0) {
      dispatchUpdateEvent();
    } else {
      dispatchStoreEvent();
    }
    // dispatch(getLabRequestReq(`?limit=20&page=0&search=&labRequestTest=${labRequestTest}`))
    setEnableEmptyAlert(false);
    setEnableStoreAlert(true);
  }

  const dispatchUpdateEvent = () => {
    const updatePayload = {
      labRequestTest: props?.match?.params?.rowInfoLabTestViewId,
      id: labRequestRequirements[0].id,
      requirements: editorState
    }
    dispatch(updateLabRequestReq(updatePayload))
  }

  const dispatchStoreEvent = () => {
    const payload = {
      labRequestTest: props?.match?.params?.rowInfoLabTestViewId,
      requirements: editorState
    }
    dispatch(addNewLabRequestReq(payload))
    // dispatch(getLabRequestReq(`?limit=20&page=0&search=&labRequestTest=${labRequestTest}`))
  }

  const handleChange = (event) => {
    setEditorState(event.target.value)
  }

  return (
    <>
      <div className="page-content pt-4 pb-4">
        <Container fluid={true} >
          <div className='d-flex align-items-center justify-content-between mb-3'>
            <h4 className='text-center text-primary'>Requerimientos especiales u observaciones</h4>
            <AnalysisRequestSaveButton handleOnClick={saveInfo} disabled={(role ==='Asesor Técnico' && labRequestTests[0]?.labRequest?.requestStatus !== 'Pendiente de envío') || labRequestTests[0]?.labRequest?.generalStatus === 'Concluida' || labRequestTests[0]?.labRequest?.generalStatus === 'Cancelada' } />
          </div>

          {enableEmptyAlert
            && <div className='d-flex m-0 ms-3 p-0'>
              <label className='m-0 p-0 d-flex align-items-center justify-content-center'>
                <span className="mdi mdi-alert-outline mdi-36px text-warning ps-4 m-0"></span>
                <h4 className='text-primary m-0 ps-1'>Los requerimientos especiales u observaciones son obligatorias</h4>
              </label>
            </div>
          }

          {(enableStoreAlert) ? (
            <div className="text-success text-center mb-5"><b>{'Se han almacenado correctamente los requerimientos'}</b></div>
          ) : null}

          <textarea
            required
            rows="12"
            type="text"
            value={editorState}
            name="requirements"
            onChange={handleChange}
            placeholder="Requerimientos"
            className="form-control text-primary rounded-3"
          />

          {/*<Editor*/}
          {/*  editorClassName="editorClassName"*/}
          {/*  toolbarClassName="toolbarClassName"*/}
          {/*  wrapperClassName="wrapperClassName"*/}
          {/*  onEditorStateChange={onEditorStateChange}*/}
          {/*/>*/}

        </Container>
      </div>
    </>
  )

}
